import { useMakeUrl, routes } from "../../lib/urls";
import { Link } from "../Link";
import { SettingsCard, SettingsHeading, SettingsRow } from "../SettingsCard";
import { Text } from "../Text";
import { Toggle } from "../Toggle";
import { Tooltip } from "../Tooltip";

export function AiProviderAccessCard({
  inheritConnectorAccess,
  connectedAppId,
  connectorName,
  isDefault,
  disabled,
  onChange,
}: {
  inheritConnectorAccess: boolean;
  connectedAppId: string | null;
  connectorName: string | null;
  isDefault: boolean;
  disabled: boolean;
  onChange: (inheritConnectorAccess: boolean) => void;
}) {
  const makeUrl = useMakeUrl();
  const blockedReason = inheritConnectorAccess
    ? null
    : !connectedAppId
      ? "Choose a connector first"
      : isDefault
        ? "The default provider must be available to everyone"
        : null;
  const toggle = (
    <div>
      <Toggle
        isOn={inheritConnectorAccess}
        disabled={disabled || blockedReason != null}
        onToggle={() => onChange(!inheritConnectorAccess)}
      />
    </div>
  );
  return (
    <SettingsCard>
      <SettingsRow>
        <SettingsHeading>
          <Text variant="text-regular-md">Restricted access</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            Only people who can use the{" "}
            {connectedAppId ? (
              <Link
                to={makeUrl(routes.modal.connector, {
                  id: connectedAppId,
                  tab: "access",
                })}
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                {connectorName ?? "selected"} connector
              </Link>
            ) : (
              "selected connector"
            )}{" "}
            can use this provider.
          </Text>
        </SettingsHeading>
        {blockedReason && !disabled ? (
          <Tooltip content={blockedReason}>{toggle}</Tooltip>
        ) : (
          toggle
        )}
      </SettingsRow>
    </SettingsCard>
  );
}
